import React, { useState } from 'react'
import CustomButton from '../components/CustomButton';
import { redirect, useNavigate } from 'react-router-dom';
import { updateViewApi } from '../callApi/view';

export default function PreScreen() {
  const router = useNavigate();

  return (
    <div className='flex flex-col justify-center items-center w'>
      <div className='p-8'>
        <img src='/img/landing.png' className='max-w-[960px] w-full'/>
      </div>
      <CustomButton txt={'เข้าสู่เว็บไซต์'}  onClick={async()=>{
        // const res = await updateViewApi()
        router('/home')
      }} />
    </div>
  )
}
